export default "__VITE_ASSET__JmFJSc$9__"